export default __webpack_public_path__ + "static/media/membre_rania.e04b2287.jpg";